module.exports = __webpack_public_path__ + "media/images/red-down-729defc66070050500f6c68a8e617303.svg";